import axios from "axios";
import { createAsyncThunk } from "@reduxjs/toolkit";

export const resetAgentPassword = createAsyncThunk(
  "agentRosterProfile/resetAgentPassword",
  async (data, thunkAPI) => {
    const { id, handleSuccess, handleError } = data;
    try {
      const resp = await axios.put(
        `${process.env.REACT_APP_BASE_URL}api/users/reset-password/${id}`,
        {},
        {
          headers: {
            Authorization: "Bearer " + localStorage.token,
            "Content-Type": "application/json",
          },
        }
      );
      if (handleSuccess) {
        handleSuccess(resp.data?.message || "Password reset successfully!");
      }
      return resp.data;
    } catch (error) {
      if (error.response) {
        if (handleError) {
          handleError(error.response.data.message);
        }
        return thunkAPI.rejectWithValue(error.response.data.message);
      } else {
        if (handleError) {
          handleError(error.message);
        }
        return thunkAPI.rejectWithValue(error.message);
      }
    }
  }
);
